import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { NotFoundScreen } from '@/common/ErrorScreen';

/**
 * A study helper news single.
 *
 * These bodies can carry `{{MEDIA}}` tokens, so `content` arrives as
 * `MediaHtml`, already resolved; nothing here rewrites it.
 */
function StudyHelperNewsPost(): ReactElement | null {
  const { t } = useTranslation();
  const { slug } = Route.useParams();
  const { data, isError, isPending } = api.getStudyHelperNewsPost.useQuery({
    path: { slug },
  });

  if (isError) return <NotFoundScreen />;
  if (isPending || data === undefined) return null;

  return (
    <ArticleDetailScreen
      article={{
        title: data.title,
        content: data.content,
        date: data.published_on,
        imageUrl: data.image_url ?? undefined,
        authorName: data.author_name,
        authorAvatarUrl: data.author_avatar_url,
      }}
      backPath="/study-helper-news/"
      notFoundMessage={t('wbs.page-not-found')}
    />
  );
}

export const Route = createFileRoute('/_app/study-helper-news/$slug')({
  component: StudyHelperNewsPost,
});
